import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

import { firebaseConfig } from './config'

export const firebaseApp = firebase.initializeApp(firebaseConfig)
export const firebaseDb = firebase.firestore()
export const firebaseAuth = firebase.auth()

const settings = { timestampsInSnapshots: true }
firebaseDb.settings(settings)



// WEBPACK FOOTER //
// ./src/firebase/firebase.js